import request from '@/utils/request2';
// 发票管理-可开票列表（保单）
export function invoiceList(data) {
  return request.post('admin/invoice/list', data);
}
// 发票申请
export function invoicing(data) {
  return request.post('admin/invoice/invoicing', data);
}
// 开票记录列表
export function invoiceRecordList(data) {
  return request.post('admin/invoice-record/list', data);
}
// 发票管理-开票记录详情
export function invoiceRecordDetail(data) {
  return request.post('admin/invoice-record/detail', data);
}
// 发票管理-发票作废
export function invoiceOffset(data) {
  return request.post('/admin/invoice/offset', data);
}